import type { RefObject } from "react"

import { useTranslation } from "react-i18next"
import type { OpenAPI } from "simplydo/interfaces"

import IdeaSidebar from "components/ideas/IdeaSidebar/IdeaSidebar"
import type { ItemRefs } from "components/ideas/useIdeaScrollTracking"

type IdeaAssessmentProps = {
  idea: OpenAPI.GET<"/ideas/{id}">["response"]
  assessment?: OpenAPI.GET<"/ideas/{id}">["response"]["assessments"][0]
  onUpdateIdea: (data: Partial<OpenAPI.PUT<"/ideas/{id}">["requestBody"]>) => void
  sectionRefs?: RefObject<ItemRefs>
  fieldRefs?: RefObject<ItemRefs>
  scrollRef?: RefObject<HTMLDivElement>
}

export const IdeaAssessment = ({
  idea,
  assessment,
  onUpdateIdea,
  sectionRefs,
  fieldRefs,
  scrollRef,
}: IdeaAssessmentProps) => {
  const { t } = useTranslation()
  return (
    <div style={{ display: "flex" }}>
      <IdeaSidebar
        idea={idea}
        assessment={assessment}
        sectionRefs={sectionRefs}
        fieldRefs={fieldRefs}
        scrollRef={scrollRef}
        isEditing={false}
      />
    </div>
  )
}
